export default "__VITE_ASSET__DIUVJZLK__"